// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
}

export const companySchema: Array<StaticFieldSchema> = [
  {
    key: 'borrowerVerification',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'borrowerVerification',
    nested: [
      {
        key: 'crmDefaultTypeId',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'borrowerVerification.crmDefaultTypeId',
      },
    ],
  },
  {
    key: 'documents',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'documents',
    nested: [
      {
        key: 'signing_key',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'documents.signing_key',
      },
      {
        key: 'signing_key_password_token',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'documents.signing_key_password_token',
      },
      {
        key: 'signer_contact',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'documents.signer_contact',
      },
      {
        key: 'signer_location',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'documents.signer_location',
      },
    ],
  },
  {
    key: 'compliance',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'compliance',
    nested: [
      {
        key: 'no_review_task_for_autocreated_cases',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'compliance.no_review_task_for_autocreated_cases',
      },
      {
        key: 'no_review_task_for_autoupdated_cases',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'compliance.no_review_task_for_autoupdated_cases',
      },
      {
        key: 'rndCompanyId',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'compliance.rndCompanyId',
      },
    ],
  },
  {
    key: 'evidence',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'evidence',
    nested: [
      {
        key: 'captureScreenshot',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'evidence.captureScreenshot',
      },
    ],
  },
  {
    key: 'communication',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'communication',
    nested: [
      {
        key: 'email_from',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'communication.email_from',
      },
      {
        key: 'email_inbound',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'communication.email_inbound',
        nested: [
          {
            key: 'monitored_emails',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'communication.email_inbound.monitored_emails',
            nested: [
              {
                key: '0',
                type: 'string',
                required: true,
                component: 'TextInput',
                fullPath: 'communication.email_inbound.monitored_emails[0]',
              },
            ],
          },
          {
            key: 'reject_others',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'communication.email_inbound.reject_others',
          },
        ],
      },
      {
        key: 'text_from_number',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'communication.text_from_number',
      },
      {
        key: 'address_from',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'communication.address_from',
        nested: [
          {
            key: 'addressLine1',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'communication.address_from.addressLine1',
          },
          {
            key: 'addressLine2',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'communication.address_from.addressLine2',
          },
          {
            key: 'city',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'communication.address_from.city',
          },
          {
            key: 'countyOrRegion',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'communication.address_from.countyOrRegion',
          },
          {
            key: 'state',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'communication.address_from.state',
          },
          {
            key: 'postalCode',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'communication.address_from.postalCode',
          },
          {
            key: 'country',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'communication.address_from.country',
          },
          {
            key: 'POBox',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'communication.address_from.POBox',
          },
          {
            key: 'timezone',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'communication.address_from.timezone',
          },
        ],
      },
      {
        key: 'enableInboundVoiceCall',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'communication.enableInboundVoiceCall',
      },
      {
        key: 'enableInboundWebChat',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'communication.enableInboundWebChat',
      },
      {
        key: 'enable_two_way_texting',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'communication.enable_two_way_texting',
      },
    ],
  },
  {
    key: 'support',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'support',
    nested: [
      {
        key: 'phone',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'support.phone',
      },
      {
        key: 'email',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'support.email',
      },
      {
        key: 'departmentName',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'support.departmentName',
      },
      {
        key: 'mailingAddress',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'support.mailingAddress',
        nested: [
          {
            key: 'addressLine1',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'support.mailingAddress.addressLine1',
          },
          {
            key: 'addressLine2',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'support.mailingAddress.addressLine2',
          },
          {
            key: 'city',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'support.mailingAddress.city',
          },
          {
            key: 'countyOrRegion',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'support.mailingAddress.countyOrRegion',
          },
          {
            key: 'state',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'support.mailingAddress.state',
          },
          {
            key: 'postalCode',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'support.mailingAddress.postalCode',
          },
          {
            key: 'country',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'support.mailingAddress.country',
          },
          {
            key: 'POBox',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'support.mailingAddress.POBox',
          },
          {
            key: 'timezone',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'support.mailingAddress.timezone',
          },
        ],
      },
      {
        key: 'outboundCallRecordingConsentScript',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'support.outboundCallRecordingConsentScript',
      },
      {
        key: 'privacyPolicyUrl',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'support.privacyPolicyUrl',
      },
      {
        key: 'phoneSupportPleaseHoldMessage',
        type: 'string',
        required: false,
        component: 'Textarea',
        fullPath: 'support.phoneSupportPleaseHoldMessage',
      },
      {
        key: 'enableVoicemailWhenClosed',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'support.enableVoicemailWhenClosed',
      },
      {
        key: 'phoneSupportClosedMessage',
        type: 'string',
        required: false,
        component: 'Textarea',
        fullPath: 'support.phoneSupportClosedMessage',
      },
      {
        key: 'phoneSupportDisabledMessage',
        type: 'string',
        required: false,
        component: 'Textarea',
        fullPath: 'support.phoneSupportDisabledMessage',
      },
      {
        key: 'phoneSupportClosedLeaveVoicemailMessage',
        type: 'string',
        required: false,
        component: 'Textarea',
        fullPath: 'support.phoneSupportClosedLeaveVoicemailMessage',
      },
      {
        key: 'enableVoicemailWhenNoAgents',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'support.enableVoicemailWhenNoAgents',
      },
      {
        key: 'phoneSupportNoAgentsLeaveVoicemailMessage',
        type: 'string',
        required: false,
        component: 'Textarea',
        fullPath: 'support.phoneSupportNoAgentsLeaveVoicemailMessage',
      },
      {
        key: 'recordAllInboundVoiceCalls',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'support.recordAllInboundVoiceCalls',
      },
      {
        key: 'recordAllOutboundVoiceCalls',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'support.recordAllOutboundVoiceCalls',
      },
      {
        key: 'textSupportRejectUnknownNumberMessage',
        type: 'string',
        required: false,
        component: 'Textarea',
        fullPath: 'support.textSupportRejectUnknownNumberMessage',
      },
      {
        key: 'textSupportPleaseWaitMessage',
        type: 'string',
        required: false,
        component: 'Textarea',
        fullPath: 'support.textSupportPleaseWaitMessage',
      },
      {
        key: 'textSupportClosedPleaseWaitMessage',
        type: 'string',
        required: false,
        component: 'Textarea',
        fullPath: 'support.textSupportClosedPleaseWaitMessage',
      },
      {
        key: 'textSupportFindNewAgentPleaseWaitMessage',
        type: 'string',
        required: false,
        component: 'Textarea',
        fullPath: 'support.textSupportFindNewAgentPleaseWaitMessage',
      },
      {
        key: 'textSupportDisabledMessage',
        type: 'string',
        required: false,
        component: 'Textarea',
        fullPath: 'support.textSupportDisabledMessage',
      },
    ],
  },
  {
    key: 'payment',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'payment',
    nested: [
      {
        key: 'disablePaymentProcessing',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'payment.disablePaymentProcessing',
      },
      {
        key: 'scheduleAutopayTransactions',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'payment.scheduleAutopayTransactions',
      },
      {
        key: 'processedByPeach',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'payment.processedByPeach',
      },
      {
        key: 'allowedCreditCardTx',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'payment.allowedCreditCardTx',
        nested: [
          {
            key: 'payment',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'payment.allowedCreditCardTx.payment',
          },
          {
            key: 'downPayment',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'payment.allowedCreditCardTx.downPayment',
          },
        ],
      },
      {
        key: 'bypassCollisionCheck',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'payment.bypassCollisionCheck',
      },
      {
        key: 'transactionLimitAmount',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'payment.transactionLimitAmount',
        numberFormat: 'currency',
      },
      {
        key: 'maxNumberNewPaymentMethodsIn30Days',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'payment.maxNumberNewPaymentMethodsIn30Days',
        numberFormat: 'integer',
      },
      {
        key: 'externalTransactions',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'payment.externalTransactions',
        nested: [
          {
            key: '0',
            type: 'object',
            required: true,
            component: 'TextInput',
            fullPath: 'payment.externalTransactions[0]',
            nested: [
              {
                key: 'transactionType',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'payment.externalTransactions[0].transactionType',
                options: [
                  'ach',
                  'debitCard',
                  'creditCard',
                  'check',
                  'payroll',
                  'moneyOrder',
                  'wire',
                  'paymentNetwork',
                ],
              },
              {
                key: 'statusTransition',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'payment.externalTransactions[0].statusTransition',
                options: ['auto', 'manual'],
              },
              {
                key: 'transitionLogic',
                type: 'object',
                required: false,
                component: 'TextInput',
                fullPath: 'payment.externalTransactions[0].transitionLogic',
                nested: [
                  {
                    key: 'type',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'payment.externalTransactions[0].transitionLogic.type',
                    options: ['numDays', 'holdDays'],
                  },
                  {
                    key: 'dayType',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'payment.externalTransactions[0].transitionLogic.dayType',
                    options: ['calendar', 'business'],
                  },
                  {
                    key: 'numDays',
                    type: 'number',
                    required: false,
                    component: 'NumberInput',
                    fullPath:
                      'payment.externalTransactions[0].transitionLogic.numDays',
                    numberFormat: 'integer',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 'paymentTypes',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'paymentTypes',
    nested: [
      {
        key: 'ach',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paymentTypes.ach',
      },
      {
        key: 'check',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paymentTypes.check',
      },
      {
        key: 'creditCard',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paymentTypes.creditCard',
      },
      {
        key: 'debitCard',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paymentTypes.debitCard',
      },
      {
        key: 'payroll',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paymentTypes.payroll',
      },
      {
        key: 'paymentNetwork',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paymentTypes.paymentNetwork',
      },
      {
        key: 'moneyOrder',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paymentTypes.moneyOrder',
      },
      {
        key: 'wire',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paymentTypes.wire',
      },
      {
        key: 'achVerification',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'paymentTypes.achVerification',
        nested: [
          {
            key: 'microdeposit',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'paymentTypes.achVerification.microdeposit',
          },
          {
            key: 'plaid',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'paymentTypes.achVerification.plaid',
          },
        ],
      },
      {
        key: 'balanceCheck',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'paymentTypes.balanceCheck',
        nested: [
          {
            key: 'plaid',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'paymentTypes.balanceCheck.plaid',
          },
        ],
      },
    ],
  },
  {
    key: 'timezone',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'timezone',
  },
  {
    key: 'openHours',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'openHours',
    nested: [
      {
        key: 'businessHours',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'openHours.businessHours',
        nested: [
          {
            key: 'normal',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'openHours.businessHours.normal',
          },
          {
            key: 'holidays',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'openHours.businessHours.holidays',
            nested: [
              {
                key: '0',
                type: 'object',
                required: true,
                component: 'TextInput',
                fullPath: 'openHours.businessHours.holidays[0]',
                nested: [
                  {
                    key: 'date',
                    type: 'string',
                    required: false,
                    component: 'TextInput',
                    fullPath: 'openHours.businessHours.holidays[0].date',
                  },
                  {
                    key: 'name',
                    type: 'string',
                    required: true,
                    component: 'TextInput',
                    fullPath: 'openHours.businessHours.holidays[0].name',
                  },
                  {
                    key: 'hours',
                    type: 'string',
                    required: false,
                    component: 'TextInput',
                    fullPath: 'openHours.businessHours.holidays[0].hours',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 'brandAssets',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'brandAssets',
    nested: [
      {
        key: 'logos',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'brandAssets.logos',
        nested: [
          {
            key: 'primary',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.logos.primary',
          },
          {
            key: 'small',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.logos.small',
          },
          {
            key: 'appLargeCentered',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.logos.appLargeCentered',
          },
          {
            key: 'appRegularNavigation',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.logos.appRegularNavigation',
          },
          {
            key: 'appCompactNavigation',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.logos.appCompactNavigation',
          },
        ],
      },
      {
        key: 'colors',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'brandAssets.colors',
        nested: [
          {
            key: 'primary',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.colors.primary',
          },
          {
            key: 'secondary',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.colors.secondary',
          },
          {
            key: 'tertiary',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.colors.tertiary',
          },
          {
            key: 'lighten',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.colors.lighten',
          },
          {
            key: 'button',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.colors.button',
          },
          {
            key: 'link',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.colors.link',
          },
          {
            key: 'secondButton',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.colors.secondButton',
          },
          {
            key: 'secondButtonBackground',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.colors.secondButtonBackground',
          },
        ],
      },
      {
        key: 'copies',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'brandAssets.copies',
        nested: [
          {
            key: 'consent',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.copies.consent',
          },
          {
            key: 'disclosures',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'brandAssets.copies.disclosures',
          },
        ],
      },
    ],
  },
  {
    key: 'requireBorrowerIdentity',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'requireBorrowerIdentity',
  },
  {
    key: 'addressValidation',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'addressValidation',
    options: ['smartyStreets', 'googleMaps'],
  },
  {
    key: 'allowPartialAddress',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'allowPartialAddress',
  },
  {
    key: 'forceCaseIdOnAgentActions',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'forceCaseIdOnAgentActions',
  },
  {
    key: 'collections',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'collections',
    nested: [
      {
        key: 'intensityLimits',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'collections.intensityLimits',
        nested: [],
      },
      {
        key: 'autoInitiate',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'collections.autoInitiate',
        nested: [
          {
            key: 'enabled',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'collections.autoInitiate.enabled',
          },
          {
            key: 'collectionCaseTypeId',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'collections.autoInitiate.collectionCaseTypeId',
          },
          {
            key: 'inspectionProcName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'collections.autoInitiate.inspectionProcName',
          },
          {
            key: 'totalOverdueAmountThreshold',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'collections.autoInitiate.totalOverdueAmountThreshold',
            numberFormat: 'currency',
          },
          {
            key: 'nPastCollectionsThreshold',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'collections.autoInitiate.nPastCollectionsThreshold',
            numberFormat: 'integer',
          },
          {
            key: 'nOverdueNoticesRequired',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'collections.autoInitiate.nOverdueNoticesRequired',
            numberFormat: 'integer',
          },
          {
            key: 'loanDaysOverdueThreshold',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'collections.autoInitiate.loanDaysOverdueThreshold',
            nested: [
              {
                key: 'weekly',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath:
                  'collections.autoInitiate.loanDaysOverdueThreshold.weekly',
                numberFormat: 'integer',
              },
              {
                key: 'everyTwoWeeks',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath:
                  'collections.autoInitiate.loanDaysOverdueThreshold.everyTwoWeeks',
                numberFormat: 'integer',
              },
              {
                key: 'twiceMonthly',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath:
                  'collections.autoInitiate.loanDaysOverdueThreshold.twiceMonthly',
                numberFormat: 'integer',
              },
              {
                key: 'monthly',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath:
                  'collections.autoInitiate.loanDaysOverdueThreshold.monthly',
                numberFormat: 'integer',
              },
            ],
          },
          {
            key: 'interactionDaysPassedThreshold',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'collections.autoInitiate.interactionDaysPassedThreshold',
            nested: [
              {
                key: 'weekly',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath:
                  'collections.autoInitiate.interactionDaysPassedThreshold.weekly',
                numberFormat: 'integer',
              },
              {
                key: 'everyTwoWeeks',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath:
                  'collections.autoInitiate.interactionDaysPassedThreshold.everyTwoWeeks',
                numberFormat: 'integer',
              },
              {
                key: 'twiceMonthly',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath:
                  'collections.autoInitiate.interactionDaysPassedThreshold.twiceMonthly',
                numberFormat: 'integer',
              },
              {
                key: 'monthly',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath:
                  'collections.autoInitiate.interactionDaysPassedThreshold.monthly',
                numberFormat: 'integer',
              },
            ],
          },
          {
            key: 'enableReviewTask',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'collections.autoInitiate.enableReviewTask',
          },
        ],
      },
      {
        key: 'autoClose',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'collections.autoClose',
        nested: [
          {
            key: 'enabled',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'collections.autoClose.enabled',
          },
          {
            key: 'closeOnlyWhenPaidOff',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'collections.autoClose.closeOnlyWhenPaidOff',
          },
        ],
      },
    ],
  },
  {
    key: 'search',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'search',
    nested: [
      {
        key: 'indexing',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'search.indexing',
        nested: [
          {
            key: 'enabled',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'search.indexing.enabled',
          },
        ],
      },
    ],
  },
  {
    key: 'auth',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'auth',
    nested: [
      {
        key: 'saml',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'auth.saml',
        nested: [
          {
            key: 'metadataUrl',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'auth.saml.metadataUrl',
          },
          {
            key: 'nameIdFormat',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'auth.saml.nameIdFormat',
          },
        ],
      },
    ],
  },
  {
    key: 'creditCounselingServicesNumber',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'creditCounselingServicesNumber',
  },
  {
    key: 'links',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'links',
    nested: [
      {
        key: 'helpUrl',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'links.helpUrl',
      },
      {
        key: 'termsOfUseUrl',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'links.termsOfUseUrl',
      },
      {
        key: 'privacyPolicyUrl',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'links.privacyPolicyUrl',
      },
      {
        key: 'eSignDisclosureUrl',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'links.eSignDisclosureUrl',
      },
    ],
  },
  {
    key: 'ui',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'ui',
    nested: [
      {
        key: 'directPaymentToDraw',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'ui.directPaymentToDraw',
        options: ['', 'shown'],
      },
      {
        key: 'mobileFooter',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'ui.mobileFooter',
        options: ['', 'hidden'],
      },
      {
        key: 'mobileHeader',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'ui.mobileHeader',
        options: ['', 'hidden'],
      },
      {
        key: 'mobileDisclosures',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'ui.mobileDisclosures',
        options: ['', 'hidden'],
      },
      {
        key: 'manageAutopayPage',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.manageAutopayPage',
        nested: [
          {
            key: 'minimumPaymentDue',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.manageAutopayPage.minimumPaymentDue',
            options: ['', 'hidden'],
          },
          {
            key: 'statementBalance',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.manageAutopayPage.statementBalance',
            options: ['', 'hidden'],
          },
        ],
      },
      {
        key: 'makePaymentPage',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.makePaymentPage',
        nested: [
          {
            key: 'remainingBalance',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.makePaymentPage.remainingBalance',
            options: ['', 'hidden'],
          },
        ],
      },
      {
        key: 'loginPage',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.loginPage',
        nested: [
          {
            key: 'fallbackAuthLink',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.loginPage.fallbackAuthLink',
            options: ['', 'hidden'],
          },
        ],
      },
      {
        key: 'managePaymentMethodsPage',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.managePaymentMethodsPage',
        nested: [
          {
            key: 'borrower',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'ui.managePaymentMethodsPage.borrower',
            nested: [
              {
                key: 'check',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.borrower.check',
                options: ['', 'hidden'],
              },
              {
                key: 'creditCard',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.borrower.creditCard',
                options: ['', 'hidden'],
              },
              {
                key: 'debitCard',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.borrower.debitCard',
                options: ['', 'hidden'],
              },
              {
                key: 'payroll',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.borrower.payroll',
                options: ['', 'hidden'],
              },
              {
                key: 'paymentNetwork',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.borrower.paymentNetwork',
                options: ['', 'hidden'],
              },
              {
                key: 'wire',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.borrower.wire',
                options: ['', 'hidden'],
              },
              {
                key: 'moneyOrder',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.borrower.moneyOrder',
                options: ['', 'hidden'],
              },
              {
                key: 'deleteButton',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.borrower.deleteButton',
                options: ['', 'hidden'],
              },
            ],
          },
          {
            key: 'agent',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'ui.managePaymentMethodsPage.agent',
            nested: [
              {
                key: 'check',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.agent.check',
                options: ['', 'hidden'],
              },
              {
                key: 'creditCard',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.agent.creditCard',
                options: ['', 'hidden'],
              },
              {
                key: 'debitCard',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.agent.debitCard',
                options: ['', 'hidden'],
              },
              {
                key: 'payroll',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.agent.payroll',
                options: ['', 'hidden'],
              },
              {
                key: 'paymentNetwork',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.agent.paymentNetwork',
                options: ['', 'hidden'],
              },
              {
                key: 'wire',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.agent.wire',
                options: ['', 'hidden'],
              },
              {
                key: 'moneyOrder',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.agent.moneyOrder',
                options: ['', 'hidden'],
              },
              {
                key: 'deleteButton',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'ui.managePaymentMethodsPage.agent.deleteButton',
                options: ['', 'hidden'],
              },
            ],
          },
        ],
      },
      {
        key: 'help',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'ui.help',
        options: ['', 'hidden'],
      },
      {
        key: 'signOut',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'ui.signOut',
        options: ['', 'hidden'],
      },
      {
        key: 'accountSettings',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'ui.accountSettings',
        options: ['', 'hidden'],
      },
      {
        key: 'contactUs',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'ui.contactUs',
        options: ['', 'hidden'],
      },
      {
        key: 'loanOptions',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.loanOptions',
        nested: [
          {
            key: 'managePaymentMethods',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.loanOptions.managePaymentMethods',
            options: ['', 'hidden'],
          },
          {
            key: 'makePayment',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.loanOptions.makePayment',
            options: ['', 'hidden'],
          },
          {
            key: 'changeDueDate',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.loanOptions.changeDueDate',
            options: ['', 'hidden'],
          },
          {
            key: 'getPayoffStatement',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.loanOptions.getPayoffStatement',
            options: ['', 'hidden'],
          },
          {
            key: 'changeNickname',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.loanOptions.changeNickname',
            options: ['', 'hidden'],
          },
          {
            key: 'manageAutopay',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.loanOptions.manageAutopay',
            options: ['', 'hidden'],
          },
          {
            key: 'drawFunds',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.loanOptions.drawFunds',
            options: ['', 'hidden'],
          },
        ],
      },
      {
        key: 'accountSettingsPage',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.accountSettingsPage',
        nested: [
          {
            key: 'profile',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.accountSettingsPage.profile',
            options: ['', 'hidden'],
          },
          {
            key: 'contactInformation',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.accountSettingsPage.contactInformation',
            options: ['', 'hidden'],
          },
          {
            key: 'commPreferences',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.accountSettingsPage.commPreferences',
            options: ['', 'hidden'],
          },
          {
            key: 'additionalContacts',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.accountSettingsPage.additionalContacts',
            options: ['', 'hidden'],
          },
          {
            key: 'paymentMethods',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.accountSettingsPage.paymentMethods',
            options: ['', 'hidden'],
          },
        ],
      },
      {
        key: 'accountSummaryPage',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.accountSummaryPage',
        nested: [
          {
            key: 'summary',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.accountSummaryPage.summary',
            options: ['', 'hidden'],
          },
          {
            key: 'loanTerms',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.accountSummaryPage.loanTerms',
            options: ['', 'hidden'],
          },
          {
            key: 'balancesDetails',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.accountSummaryPage.balancesDetails',
            options: ['', 'hidden'],
          },
          {
            key: 'promotions',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.accountSummaryPage.promotions',
            options: ['', 'hidden'],
          },
          {
            key: 'merchantDetails',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.accountSummaryPage.merchantDetails',
            options: ['', 'hidden'],
          },
          {
            key: 'cardDetails',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.accountSummaryPage.cardDetails',
            options: ['', 'hidden'],
          },
        ],
      },
      {
        key: 'caseTypeOrdering',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'ui.caseTypeOrdering',
        nested: [
          {
            key: '0',
            type: 'object',
            required: true,
            component: 'TextInput',
            fullPath: 'ui.caseTypeOrdering[0]',
            nested: [
              {
                key: 'category',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'ui.caseTypeOrdering[0].category',
              },
              {
                key: 'caseTypes',
                type: 'array',
                required: false,
                component: 'ArrayEditor',
                fullPath: 'ui.caseTypeOrdering[0].caseTypes',
                nested: [
                  {
                    key: '0',
                    type: 'string',
                    required: true,
                    component: 'TextInput',
                    fullPath: 'ui.caseTypeOrdering[0].caseTypes[0]',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        key: 'agentDashboardTools',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.agentDashboardTools',
        nested: [
          {
            key: 'enabled',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'ui.agentDashboardTools.enabled',
          },
          {
            key: 'dashboardToolDetails',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'ui.agentDashboardTools.dashboardToolDetails',
            nested: [
              {
                key: '0',
                type: 'object',
                required: true,
                component: 'TextInput',
                fullPath: 'ui.agentDashboardTools.dashboardToolDetails[0]',
                nested: [
                  {
                    key: 'name',
                    type: 'string',
                    required: false,
                    component: 'TextInput',
                    fullPath:
                      'ui.agentDashboardTools.dashboardToolDetails[0].name',
                  },
                  {
                    key: 'url',
                    type: 'string',
                    required: false,
                    component: 'TextInput',
                    fullPath:
                      'ui.agentDashboardTools.dashboardToolDetails[0].url',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        key: 'websiteTitle',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.websiteTitle',
      },
      {
        key: 'favicon',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.favicon',
      },
      {
        key: 'projectSlug',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.projectSlug',
      },
      {
        key: 'phoneDisclosureNote',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'ui.phoneDisclosureNote',
        options: ['', 'shown'],
      },
      {
        key: 'analyticsScript',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.analyticsScript',
      },
      {
        key: 'headScripts',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.headScripts',
      },
      {
        key: 'eSignDisclosure',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'ui.eSignDisclosure',
        options: ['', 'hidden'],
      },
      {
        key: 'termsOfUse',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'ui.termsOfUse',
        options: ['', 'hidden'],
      },
      {
        key: 'privacyPolicy',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'ui.privacyPolicy',
        options: ['', 'hidden'],
      },
      {
        key: 'dashboard',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'ui.dashboard',
        nested: [
          {
            key: 'cases',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.dashboard.cases',
            options: ['', 'hidden'],
          },
          {
            key: 'interactions',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'ui.dashboard.interactions',
            options: ['', 'hidden'],
          },
        ],
      },
    ],
  },
  {
    key: 'statements',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'statements',
    nested: [
      {
        key: 'isMailStatementAllowed',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'statements.isMailStatementAllowed',
      },
      {
        key: 'defaultStatementChannel',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'statements.defaultStatementChannel',
        options: ['email', 'mail'],
      },
      {
        key: 'overdueAmountInMinPaymentOverride',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'statements.overdueAmountInMinPaymentOverride',
      },
    ],
  },
  {
    key: 'zendesk',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'zendesk',
    nested: [
      {
        key: 'sso',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'zendesk.sso',
        nested: [
          {
            key: 'enabled',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'zendesk.sso.enabled',
          },
          {
            key: 'subdomain',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'zendesk.sso.subdomain',
          },
          {
            key: 'sharedSecretToken',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'zendesk.sso.sharedSecretToken',
          },
        ],
      },
    ],
  },
  {
    key: 'tasks',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'tasks',
    nested: [
      {
        key: 'disableTaskTypes',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'tasks.disableTaskTypes',
        nested: [
          {
            key: '0',
            type: 'enum',
            required: true,
            component: 'Select',
            fullPath: 'tasks.disableTaskTypes[0]',
            options: [
              'answerInboundVoiceCall',
              'handleInboundInteraction',
              'handleUnboundInboundInteraction',
              'makeScheduledCall',
              'replyToNewConvo',
              'replyToNewText',
              'replyToNewWebChat',
              'replyToAbandonedWebChat',
              'reviewEscalatedCaseAgent',
              'reviewEscalatedCaseAgentUrgent',
              'reviewEscalatedCaseTeam',
              'reviewEscalatedCaseTeamUrgent',
              'reviewDocumentUpload',
              'reviewSnoozedCase',
              'reviewAutoCreatedCase',
              'reviewAutoUpdatedCase',
              'reviewCaseInstructions',
              'reviewVoicemail',
              'smartReviewCase',
            ],
          },
        ],
      },
      {
        key: 'disableTaskRouter',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'tasks.disableTaskRouter',
      },
      {
        key: 'channelCapacities',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'tasks.channelCapacities',
        nested: [
          {
            key: 'default',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'tasks.channelCapacities.default',
            numberFormat: 'integer',
          },
          {
            key: 'voice',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'tasks.channelCapacities.voice',
            numberFormat: 'integer',
          },
          {
            key: 'chat',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'tasks.channelCapacities.chat',
            numberFormat: 'integer',
          },
          {
            key: 'email',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'tasks.channelCapacities.email',
            numberFormat: 'integer',
          },
          {
            key: 'text',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'tasks.channelCapacities.text',
            numberFormat: 'integer',
          },
        ],
      },
      {
        key: 'enableCaseOwnership',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'tasks.enableCaseOwnership',
      },
    ],
  },
  {
    key: 'monitoring',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'monitoring',
    nested: [
      {
        key: 'criteria',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'monitoring.criteria',
        options: ['borrowerStatus', 'borrowerAndLoanStatus'],
      },
      {
        key: 'scraCaseCreationCriteria',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'monitoring.scraCaseCreationCriteria',
        options: ['borrowerOnly', 'borrowerAndLoan'],
      },
    ],
  },
  {
    key: 'dataOutbox',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'dataOutbox',
    nested: [
      {
        key: 'destinationProvider',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'dataOutbox.destinationProvider',
        options: ['gcp', 'aws', 'azure'],
      },
      {
        key: 'destinationBucket',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'dataOutbox.destinationBucket',
      },
      {
        key: 'destinationRegion',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'dataOutbox.destinationRegion',
      },
      {
        key: 'googleServiceAccount',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'dataOutbox.googleServiceAccount',
      },
      {
        key: 'fileFormat',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'dataOutbox.fileFormat',
        options: ['parquet', 'avro'],
      },
      {
        key: 'compressionFormat',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'dataOutbox.compressionFormat',
        options: ['gzip', 'snappy'],
      },
      {
        key: 'deliveryFrequency',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'dataOutbox.deliveryFrequency',
        options: ['15m', '1h', '1d'],
      },
    ],
  },
  {
    key: 'webhooks',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'webhooks',
    nested: [
      {
        key: 'requestTimeoutSeconds',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'webhooks.requestTimeoutSeconds',
        numberFormat: 'integer',
      },
    ],
  },
  {
    key: 'aIFeatures',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'aIFeatures',
    nested: [
      {
        key: 'enableCallTranscription',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'aIFeatures.enableCallTranscription',
      },
    ],
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(companySchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(companySchema)
}
